import api from "../axiosIntercepture";

export const getalltenents = async () => {
    try {
        const response = await api.post("tenant/getalltenents");
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

// response / error helpers
const handleResponse = (res) => res?.data ?? res;
const handleError = (err) => {
    const payload = err?.response?.data ?? err?.response ?? err?.message ?? err;
    throw payload;
};

// Fetch tenant settings (POST { tenantId })
export const getTenantSettings = async (tenantId) => {
    try {
        const res = await api.post("tenant/gettenentssettings", { tenantId });
        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
};

export const getSystemCap = async () => {
    try {
        const res = await api.post("tenant/get-system-cap");
        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
};


export const updateTenantCapabilities = async (capability) => {
    try {
        const res = await api.post("tenant/update-tenant-capabilities", capability);
        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
};

// Create tenant settings (POST)
export const createTenantSetting = async (payload) => {
    try {
        const res = await api.post("tenant/createSetting", payload);
        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
};

// Update tenant settings (PUT)
export const updateTenantSetting = async (payload) => {
    try {
        const res = await api.post("tenant/updateSetting", payload);
        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
}

export const getalltenantusers = async () => {
    try {
        const response = await api.post("tenant/getallmyusers");
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const createUsersRoles = async (roleData) => {
    try {
        const response = await api.post("auth/roles/create",roleData);
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const createTenantUser = async (data) => {
    try {
        const response = await api.post("tenant/registeruser", data);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const getAllPartners = async (id) => {
    try {
        const res = await api.post('tenant/fetch-externals');
        return res.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const getAllModules = async (id) => {
    try {
        const res = await api.post(`global/get-all-modules`);
        return res.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const getAllModulesAdmin = async (id) => {
    try {
        const res = await api.post(`global/get-all-modules-admin`);
        return res.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}



export const getUsersRoles = async (roleId,page, pageSize) => {
    try {
        const response = await api.post(roleId ?`auth/roles/fetch?id=${roleId}` : `auth/roles/fetch?limit=${pageSize}&page=${page+1}`,);
        return response?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const getUsersRolesList = async (page, pageSize) => {
    try {
        const response = await api.post(`auth/roles/fetch?limit=${pageSize}&page=${page+1}`,);
        return response?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const getUsersRolesSelect = async (roleId) => {
    try {
        const response = await api.post(roleId ?`auth/roles/fetch?id=${roleId}` : "auth/roles/fetch-select",);
        return response?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const updateUsersRoles = async (roleId,data) => {
    try {
        const response = await api.post(`/auth/roles/update/${roleId}`,data);
        return response?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const createUser = async (data) => {
    try {
        const res = await api.post('tenant/create-user', data);
        return res?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const updateUser = async (data, id) => {
    try {
        const res = await api.post(`tenant/update-user/${id}`, data);
        return res?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const fetchAllUsers = async (page, pageSize) => {
    try {
        const res = await api.post(`tenant/fetch-user?limit=${pageSize}&page=${page+1}`);
        return res?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}
export const createSetting = async (payload) => {
    try {
        const response = await api.post("tenant/createSetting", payload);
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}
export const updateSetting = async (payload) => {
    try {
        const response = await api.post("tenant/updateSetting", payload);
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

// Fetch file logs (GET with tenantId)
export const getFileLogsByTenant = async (tenantId) => {
  try {
    // 1. The URL is now clean
    // 2. The data is passed as an object in the second argument
    const res = await api.post(`filelog/get-log`, {
      tenantId,
 
    });

    return res?.data ?? res;
  } catch (err) {
    throw err?.response?.data?.message || err?.message || "Failed to fetch file logs";
  }
};


export const downloadFile = async (fileID) => {
    try {
        const response =  await api.post(`oci-upload/downloadfile?fileId=${fileID}`);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}



export const getUsersRolesAdminList = async (page, pageSize) => {
    try {
        const response = await api.post(`auth/roles/fetch-admin-roles?limit=${pageSize}&page=${page+1}`,);
        return response?.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}